import React from "react";

import { css } from "@emotion/css";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { ProfilePicture } from "@/uiKit/atoms/ProfilePicture.tsx";
import { TooltipMenuAction } from "@/uiKit/atoms/TooltipMenu.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type UserMenuProps = {
  firstName: string;
  lastName: string;
  profilePictureUrl?: string;
  onDisconnect: () => void;
  /** Appended to every id, to keep them unique when the menu is rendered in both navigation bars. */
  idSuffix?: string;
};

export const UserMenu: React.FC<UserMenuProps> = ({
  firstName,
  lastName,
  profilePictureUrl,
  onDisconnect,
  idSuffix = "",
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <TooltipMenuAction
      popupId={`user-menu${idSuffix}`}
      openOnHover
      placement="right-end"
      actions={[
        <Link id={`nav-account${idSuffix}`} to="/account" key="account">
          {t("pages.account.title")}
        </Link>,
        <div id={`disconnect-button${idSuffix}`} key="disconnect" onClick={onDisconnect}>
          <Typography variant="body">{t("navbar.disconnect")}</Typography>
        </div>,
      ]}
    >
      <div id={`user-account-menu${idSuffix}`} className={styles.picture}>
        <ProfilePicture firstName={firstName} lastName={lastName} src={profilePictureUrl} size="large" />
      </div>
    </TooltipMenuAction>
  );
};

const makeStyles = () => ({
  picture: css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    height: 100%;
  `,
});
